<template>
    <div class="paas-main-2">
        <!-- 头部 -->
        <headers></headers>
        <div v-if="langluageType == 'ch'">
            <section class="ban">
                <div class="col"></div>
            </section>
            <div class="bg-map2" style="margin-top: 150px;">
                <section class="col" style=" padding-bottom: 100px;">
                    <h4 class="title3" style="margin-bottom: 30px;">商旅解决方案</h4>
                    <ul class="list6">
                        <li>
                            <img src="../images/img-4-1.png" alt="">
                            <div>展会、会议接待服务</div>
                        </li>
                        <li>
                            <img src="../images/img-4-2.png" alt="">
                            <div>商旅计划的制定与实施</div>
                        </li>
                        <li>
                            <img src="../images/img-4-3.png" alt="">
                            <div>租车、签证等单项服务</div>
                        </li>
                        <li>
                            <img src="../images/img-4-4.png" alt="">
                            <div>团队旅游服务</div>
                        </li>
                        <li>
                            <img src="../images/img-4-5.png" alt="">
                            <div>旅游产品优惠服务</div>
                        </li>
                    </ul>
                </section>
            </div>
            <div class="">
                <section class="col" style="padding-top: 50px; padding-bottom: 50px;">
                    <h4 class="title3" style="margin-bottom: 30px;">成本节省方案</h4>
                    <div class="">
                        <ul class="list7">
                            <li>
                                <div class="">
                                    <img src="../images/img-4-6.png" alt="">
                                    <p>航空机票协议优惠价格</p>
                                </div>
                                <a href="#aaaa">联系我们</a>
                            </li>
                            <li>
                                <div class="">
                                    <img src="../images/img-4-7.png" alt="">
                                    <p>在线预订酒店</p>
                                </div>
                                <a href="http://shop.exposcm.com/Print/List/65" target="_blank">预订酒店</a>
                            </li>
                            <li>
                                <div class="">
                                    <img src="../images/img-4-8.png" alt="">
                                    <p>旅游景点优惠价格</p>
                                </div>
                                <a href="javascript:;">联系我们</a>
                            </li>
                        </ul>
                    </div>
                </section>
                

                
            </div>
            <div style="background-color: #F9FAFB;">
                <section class="col box-3">
                    <h4 class="title3" style="margin-bottom: 50px;">服务优势与保障</h4>
                    <ul class="list8">
                        <li><img src="../images/icon-4-1.png" alt=""><p>先进的管理理念</p></li>
                        <li><img src="../images/icon-4-2.png" alt=""><p>完善的服务保障体系</p></li>
                        <li><img src="../images/icon-4-3.png" alt=""><p>广泛的服务网络</p></li>
                        <li><img src="../images/icon-4-4.png" alt=""><p>专业高效的团队</p></li>
                        <li><img src="../images/icon-4-5.png" alt=""><p>专业高效的团队</p></li>
                    </ul>
                </section>
            </div>
            <i id="aaaa"></i>
            <h4 class="title3" style="margin-bottom: 30px;margin-top: 100px;font-size: 26px;">服务联系</h4>
            <div class="box-fwlx">
                <section class="col box-3 ">
                    <div class="box-fwlx-con">
                        <div class="div1">
                            <p>企微客服</p>
                            <img src="../images/img-kf.png" alt="">
                            <p>首席客服热线</p>
                            <span>010-86460766-861</span>
                        </div>
                        
                            <ul class="ul1">
                                <form id="form-zx2" action="">
                                    <li class="li1">
                                        <label for="">公司名称</label>
                                        <input name="compnay" type="text" maxlength="50">
                                    </li>
                                    <li class="li1">
                                        <label for="">所在行业</label>
                                        <input name="industry" type="text" maxlength="30">
                                    </li>
                                    <li class="li1">
                                        <label for="">您的姓名</label>
                                        <input name="username" type="text" maxlength="20">
                                    </li>
                                    <li class="li1">
                                        <label for="">手机号码</label>
                                        <input name="phone" type="text">
                                    </li>
                                    <li>
                                        <label for="">咨询需求</label>
                                        <textarea name="content" id="" maxlength="200"></textarea>
                                    </li>
                                    <li>
                                        <a class="btn" id="btn-zx-sub2" href="javascript:;">立即发送</a>
                                    </li>
                                </form>
                            </ul>
                        
                    </div>
                </section>
            </div>
        </div>
        <div v-else>
            <section class="ban bgcImg" style="background-size: cover !important;">
                <div class="col"></div>
            </section>
            <div class="bg-map2" style="margin-top: 150px;">
                <section class="col" style=" padding-bottom: 100px;">
                    <h4 class="title3" style="margin-bottom: 30px;color: #333333;font-size: 30px;">Business Travel Solutions</h4>
                    <ul class="list6">
                        <li>
                            <img src="../images/img-4-1.png" alt="">
                            <div style="line-height: normal;margin-top: 31px;">Exhibition and conference reception services</div>
                        </li>
                        <li>
                            <img src="../images/img-4-2.png" alt="">
                            <div style="line-height: normal;margin-top: 31px;">Development and implementation of business travel plans</div>
                        </li>
                        <li>
                            <img src="../images/img-4-3.png" alt="">
                            <div style="line-height: normal;margin-top: 31px;">Car hire, visa and other individual services</div>
                        </li>
                        <li>
                            <img src="../images/img-4-4.png" alt="">
                            <div style="line-height: normal;margin-top: 31px;">Group travel service</div>
                        </li>
                        <li>
                            <img src="../images/img-4-5.png" alt="">
                            <div style="line-height: normal;margin-top: 31px;">Preferential services for tourism products</div>
                        </li>
                    </ul>
                </section>
            </div>
            <div class="">
                <section class="col" style="padding-top: 50px; padding-bottom: 50px;">
                    <h4 class="title3" style="margin-bottom: 30px;color: #333333;font-size: 30px;">Cost-saving programmes</h4>
                    <div class="">
                        <ul class="list7">
                            <li>
                                <div class="">
                                    <img src="../images/img-4-6.png" alt="">
                                </div>
                                <a href="#aaaa">Contact Us</a>
                            </li>
                            <li>
                                <div class="">
                                    <img src="../images/img-4-7.png" alt="">
                                </div>
                                <a href="http://shop.exposcm.com/Print/List/65" target="_blank">Book a hotel</a>
                            </li>
                            <li>
                                <div class="">
                                    <img src="../images/img-4-8.png" alt="">
                                </div>
                                <a href="javascript:;">Contact Us</a>
                            </li>
                        </ul>
                    </div>
                </section>
                

                
            </div>
            <div style="background-color: #F9FAFB;margin-top: 123px;">
                <section class="col box-3">
                        <h4 class="title3" style="margin-bottom: 50px;font-size: 30px;color: #333333;font-size: 30px;">Service advantages and guarantees</h4>
                        <ul class="list8">
                            <li><img src="../images/icon-4-1.png" alt="" style="width: 88px;height: 88px;"><p style="font-size: 14px;">Advanced management concept</p></li>
                            <li><img src="../images/icon-4-2.png" alt="" style="width: 88px;height: 88px;"><p style="font-size: 14px;">Perfect service guarantee system</p></li>
                            <li><img src="../images/icon-4-3.png" alt="" style="width: 88px;height: 88px;"><p style="font-size: 14px;">Extensive service network</p></li>
                            <li><img src="../images/icon-4-4.png" alt="" style="width: 88px;height: 88px;"><p style="font-size: 14px;">Professional and efficient team</p></li>
                            <li><img src="../images/icon-4-5.png" alt="" style="width: 88px;height: 88px;"><p style="font-size: 14px;">Professional and efficient team</p></li>
                        </ul>
                    </section>
            </div>
            <i id="aaaa"></i>
            <h4 class="title3" style="margin-bottom: 30px;margin-top: 100px;color: #333333;font-size: 30px;">Service contact</h4>
                <div class="box-fwlx">
                    <section class="col box-3 ">
                        <div class="box-fwlx-con">
                            <div class="div1">
                                <p>WeChat Service</p>
                                <img src="../images/secCode.png" alt="">
                                <p>Chief Customer Service Hotline</p>
                                <span>010-86460766-861</span>
                            </div>
                            
                                <ul class="ul1">
                                    <form id="form-zx2" action="">
                                        <li class="li1">
                                            <label for="">Company name</label>
                                            <input name="compnay" type="text" maxlength="50">
                                        </li>
                                        <li class="li1">
                                            <label for="">industry</label>
                                            <input name="industry" type="text" maxlength="30">
                                        </li>
                                        <li class="li1">
                                            <label for="">Your name</label>
                                            <input name="username" type="text" maxlength="20">
                                        </li>
                                        <li class="li1">
                                            <label for="">Mobile phone number</label>
                                            <input name="phone" type="text">
                                        </li>
                                        <li>
                                            <label for="">Consulting demand</label>
                                            <textarea name="content" id="" maxlength="200"></textarea>
                                        </li>
                                        <li>
                                            <a class="btn" id="btn-zx-sub2" href="javascript:;">Send Now</a>
                                        </li>
                                    </form>
                                </ul>
                            
                        </div>
                    </section>
                </div>
        </div>
        
        <!-- 尾部 -->
        <footers></footers>
        <!-- 右侧吸附客服咨询按钮 -->
        <contact></contact>
    </div>
</template>
    <script>
    import headers from '@/common/header';
    import footers from '@/common/Footer';
    import contact from '@/components/contact';
    export default {
        components: {
            headers,
            footers,
            contact
        },
        data(){
            return {
                langluageType:sessionStorage.getItem('langluageType')||'ch',
            }
        }
    }
            
    </script>
    <style scoped>
    .bgcImg {
        background: url(../images/ban-7-1-1.png) center !important;
    }
    </style>


// WEBPACK FOOTER //
// src/page/paas-2.vue